import React, { useState, useEffect } from "react"
import configData from '../../../../temp/config'

const selectedData = [];

const Category = (props) => {

    const [checkboxes, setCheckboxes] = useState([])
    const [arraydata, setArraydata] = useState(selectedData)

    useEffect(() => {        
        let data = props.choices   
        setCheckboxes(
            data.map((d, i) => {
                return {
                    select: false,
                    label: d.fields.labelName.value,
                    id: d.id 
                }
            })
        )
        setArraydata(selectedData)
    }, [])

    useEffect(() => {
        if(!props.selectState){
            let data = props.choices     
            setCheckboxes(
                data.map((d, i) => {
                    return {
                        select: false,
                        label: d.fields.labelName.value,
                        id: d.id 
                    }
                })
            )
        }
    }, [props.selectState])
    
    const updateOne = (event, data, category, id) => {
        let checked = event.target.checked
        setCheckboxes(
            checkboxes.map((d, i) => {
                if(d.id === id){                    
                    d.select = checked
                    props.updateresult(`{${id}}`,category)
                }                                
                return d;
            })
        )
    }
    
    return(
        <div className="categoryblk">
            <div className="catheader">
                <img src={`${configData.sitecoreApiHost}${props.icon.src}`} />
                <h5 className="heading">{props.title}</h5>
            </div>            
            <div className="selectionbox">
                {
                    checkboxes.map((d, index) => {
                        return <label 
                                    key={index}
                                    className={ d.select ? 'checkbox-label active' : 'checkbox-label' }
                                    //htmlFor={`${d.label}-id`}
                                    htmlFor={d.id}
                                    //onClick={ () => {props.onchange(true) }} 
                                    >
                                    <input
                                        type="checkbox"
                                        name={d.label}
                                        //id={`${d.label}-id`}
                                        id={d.id}
                                        checked={d.select}
                                        onChange={(event) => updateOne(event, d.label, props.category, d.id)}                                            
                                        area-labelledby="checkbox-label"
                                    />
                                    {d.label}
                                </label>
                    })
                }                
            </div>
        </div>            
    )
}

export default Category;
